module.exports = __webpack_public_path__ + "img/peri.4de3de61.jpg";